export default "__VITE_ASSET__BUUDBhsl__"